import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC} from 'react';
import {
  ButtonsWrapper,
  ModalContent,
  ModalWrapper,
  DeleteUsersEmailsWrapper,
} from './DeleteTestModal.styles';
import Button from '@atoms/Button';
import Text from '@atoms/Text';
import {ISubsystem} from '@types';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '@store';
import {deleteSubsystem} from '@store/slices/systems';

interface Props {
  isOpened: boolean;
  subsystem: ISubsystem;
  onCloseRequest: () => void;
}

const DeleteSubsystemModal: FC<Props> = ({isOpened, onCloseRequest, subsystem}) => {
  const dispatch = useDispatch<AppDispatch>();

  const DeleteSubsystem = () => {
    if (subsystem?.id) {
      dispatch(deleteSubsystem(subsystem.id));
    }
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader title={'Удалить подсистему'} onClose={onCloseRequest} />
        <ModalContent>
          <DeleteUsersEmailsWrapper>
            <Text text={`Вы уверены, что хотите удалить подсистему `} display="inline" />
            <Text text={`${subsystem?.name}`} type="bodyM" display="inline" />
            <Text text="?" display="inline" />
            <Text text="Это действие необратимо." />
          </DeleteUsersEmailsWrapper>
        </ModalContent>
        <ButtonsWrapper>
          <Button
            fullWidth
            title="Удалить"
            variant="filled"
            redButton
            onClick={DeleteSubsystem}
          />
          <Button
            fullWidth
            title="Отменить"
            onClick={() => {
              onCloseRequest();
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default DeleteSubsystemModal;
